import { render, staticRenderFns } from "./PreviewData.vue?vue&type=template&id=0f7cf902&scoped=true&"
import script from "./PreviewData.vue?vue&type=script&lang=js&"
export * from "./PreviewData.vue?vue&type=script&lang=js&"
import style0 from "./PreviewData.vue?vue&type=style&index=0&id=0f7cf902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7cf902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
